import Select from 'react-select'
import React, {FC, useEffect, useMemo, useState} from 'react'
import moment from 'moment-timezone'
import DatePicker from 'react-datepicker'
import ReactPaginate from 'react-paginate'
import QuickMessageDrawerInner from '../../../../_metronic/partials/layout/drawer-messenger/Quickmessge'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import {Button, Modal, OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import {MessageType} from './Types'
import {useMessageReport} from './hooks/useMessageReport'
import {
  CampType,
  MessageReportItems,
  MessageReportParams,
  MessageReportResponse,
} from '../../../../services/cellcast.v2.types'
import {useLoadedData} from '../../../hooks/useGetLoadedData'
import {
  useLazyAllMessageCreditUsageReportQuery,
  useLazyAllMessageReportExportQuery,
  useLazyAllMessageReportQuery,
  useLazyGetMessageCreditUsageReportExportQuery,
} from '../../../../services/cellcast.v2'
import {MessageDeliveryOptions} from './Common'
import NodataYet from '../../../Components/NodataYet'
import {KTSVG} from '../../../../_metronic/helpers'
import {ENV} from '../../../Utils/_helpers/EnvHelper'
import {useSelector, useDispatch} from 'react-redux'
import {
  getApikeyListData,
  getApiKeysListOfuser,
} from '../accounts/ApiKeys/ApikeysSlices/ApiKeysSlices'
import {
  getAllUserDetails,
  getDefaultRegion,
} from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {toast} from 'react-toastify'
import {useLazyQuickMessageReportsQuery} from '../../../../services/cellcast.v3'
import {useMessageReport as useMessageReportv3} from './hooks/useMessageReportv3'
import VCardPreview from '../../../Components/VCardPreview'
import {REGION} from '../../../Utils/Constant/ConstantForWebsite'
import {
  useCancelScheduleQuickMessageMutation,
  useGetDashboardQMAndAPIStatisticQuery,
  useGetDashboardMessageSentVsCreditCostQuery,
} from '../../../../services/cellcast'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'
import ReactApexChart from 'react-apexcharts'

const ActivityLogsPageAu: FC = () => {
  const {
    params: smsParams,
    setParams: setSmsParams,
    fetchData: smsData,
    setTriggerFetch: setSmsTriggerFetch,
  } = useMessageReport(CampType.sms, useLazyAllMessageReportQuery)

  const {
    params: mmsParams,
    setParams: setMmsParams,
    fetchData: mmsData,
    setTriggerFetch: setMmsTriggerFetch,
  } = useMessageReport(CampType.mms, useLazyAllMessageReportQuery)

  const [quickMessagePopup, setQuickMessagePopup] = useState(false)

  return (
    <div className='row'>
      {AuthenticateUser('send-quick-sms') && quickMessagePopup && (
        <QuickMessageDrawerInner
          handleClose={() => setQuickMessagePopup(false)}
          show={quickMessagePopup}
        />
      )}

      <QuickMessagesGroup campType={CampType.sms} />
      <QuickMessages
        params={smsParams}
        setParams={setSmsParams}
        isFetching={smsData.isFetching}
        isLoading={smsData.isLoading}
        data={smsData.data}
        triggerFetch={setSmsTriggerFetch}
      />

      <QuickMessagesGroup campType={CampType.mms} />
      <QuickMessages
        params={mmsParams}
        setParams={setMmsParams}
        isFetching={mmsData.isFetching}
        isLoading={mmsData.isLoading}
        data={mmsData.data}
        triggerFetch={setMmsTriggerFetch}
      />
    </div>
  )
}

const ActivityLogsPageRegion: FC = () => {
  const {
    params: smsUsParams,
    setParams: setSmsUsParams,
    fetchData: smsUsData,
    setTriggerFetch: setSmsUsTriggerFetch,
  } = useMessageReportv3(CampType.sms, useLazyQuickMessageReportsQuery)

  const [quickMessagePopup, setQuickMessagePopup] = useState(false)

  return (
    <div className='row'>
      {AuthenticateUser('send-quick-sms') && quickMessagePopup && (
        <QuickMessageDrawerInner
          handleClose={() => setQuickMessagePopup(false)}
          show={quickMessagePopup}
        />
      )}

      {/* <QuickMessagesGroup campType={CampType.sms} /> */}
      <QuickMessagesRegion
        params={smsUsParams}
        setParams={setSmsUsParams}
        isFetching={smsUsData.isFetching}
        isLoading={smsUsData.isLoading}
        data={smsUsData.data}
        triggerFetch={setSmsUsTriggerFetch}
      />
    </div>
  )
}

const ActivityLogsPage: FC = () => {
  const userRegion = useSelector(getDefaultRegion)

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getApiKeysListOfuser())
  }, [])

  return [REGION.UK, REGION.US].includes(userRegion) ? (
    <ActivityLogsPageRegion />
  ) : (
    <ActivityLogsPageAu />
  )
}

type QuickMessageProps = {
  isFetching: boolean
  isLoading: boolean
  data: MessageReportResponse | undefined
  params: MessageReportParams
  setParams: (params: MessageReportParams) => void
  triggerFetch: (isFetch: boolean) => void
}
const QuickMessages: FC<QuickMessageProps> = (props) => {
  const userData = useSelector(getAllUserDetails)

  const [requestFromOptions, setRequestFromOptions] = useState([
    {
      label: 'select message source type',
      options: [],
    },
    {
      label: 'Non Api',
      options: [
        {
          label: 'Quick Message',
          value: 'APP',
        },
        {
          label: 'Email To Sms',
          value: 'EMAIL',
        },
      ],
    },
    {
      label: 'API',
      options: [],
    },
  ])

  const apikeyListData = useSelector(getApikeyListData)

  const {calculate, loadedData, setLoadedData} = useLoadedData()
  const {isFetching, isLoading, data, params, setParams, triggerFetch} = props

  const API_DOMAIN = ENV().REACT_APP_DOMAIN

  const today = new Date() // Current date
  const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([sevenDaysAgo, new Date()])
  const [startDate, endDate] = dateRange

  const [showImageUrl, setImageUrl] = useState('')
  const [isVCard, setIsVCard] = useState(false)
  const [showImageModal, setShowImageModal] = useState(false)

  const [
    cancelQuickMessage,
    {isLoading: cancelCampaignLoading},
  ] = useCancelScheduleQuickMessageMutation()
  const [isOpenCancelConfirmation, setIsOpenCancelConfirmation] = useState(false)
  const [cancelIdParam, setCancelIdParam] = useState('')

  const cancelSendingMessageConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenCancelConfirmation}
        handleClose={() => {
          setIsOpenCancelConfirmation(false)
          setCancelIdParam('')
        }}
        Message={'Are you sure, you want to cancel this campaign ?'}
        confirm={() => {
          if (cancelIdParam) {
            cancelQuickMessage({
              messageId: cancelIdParam,
              type: params.campType || 'sms',
            })
              .then((res) => {
                if ('data' in res) {
                  toast.success(res.data?.message)
                } else if ('error' in res) {
                  toast.error(res.error)
                  console.error('Error cancel campaign :', res.error)
                }
              })
              .catch((err) => {
                toast.error(err.error)
              })
              .finally(() => {
                setIsOpenCancelConfirmation(false)
                setCancelIdParam('')
                triggerFetch(true)
              })
          }
        }}
        confirmBtnTitle='Yes, cancel campaign'
      />
    ),
    [isOpenCancelConfirmation, cancelIdParam, cancelQuickMessage]
  )

  const setDateParams = (dateRangeParams: [Date | null, Date | null]) => {
    let [startDate, endDate] = dateRangeParams

    if (endDate === null) {
      endDate = new Date()
    }

    setParams({
      ...params,
      fromDate: moment(startDate).format('YYYY-MM-DD'),
      toDate: moment(endDate).format('YYYY-MM-DD'),
    })

    triggerFetch(true)
    setDateRange(dateRangeParams)
  }

  const [getApiExport, {isLoading: isLoadingDownload}] = useLazyAllMessageReportExportQuery()

  const donwloadData = () => {
    getApiExport(params)
      .unwrap()
      .then((res) => {
        window.open(`${API_DOMAIN}${res.data.downloadurl}`, '_self')
      })
  }

  useEffect(() => {
    if (data) {
      const loadedData = calculate(
        data && data.data.current ? data.data.current : 1,
        params.limit,
        data && data.data.total ? data.data.total : 0
      )
      setLoadedData(loadedData)
    }
  }, [isLoading, isFetching])

  useEffect(() => {
    if (apikeyListData && Array.isArray(apikeyListData)) {
      const apiKeyOptions = apikeyListData?.map((el: any) => ({
        label: el?.name,
        value: el?.name,
      }))

      if (apiKeyOptions.length > 0) {
        const tmpFilter: any = [...requestFromOptions]
        tmpFilter[3] = {
          label: 'API',
          options: apiKeyOptions,
        }

        setRequestFromOptions(tmpFilter)
      }
    }
  }, [apikeyListData])

  const ImagePreviewModal = useMemo(
    () => (
      <ImageModal
        show={showImageModal}
        isVCard={isVCard}
        url={showImageUrl}
        onClose={() => {
          setShowImageModal(false)
          setImageUrl('')
        }}
      />
    ),
    [showImageModal, showImageUrl]
  )

  return (
    <div className='mt-8'>
      {cancelSendingMessageConfirmation}
      {ImagePreviewModal}
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-10'>
          <div className='d-flex flex-column w-100'>
            <h3 className='card-title align-items-start  flex-column'>
              <span className='card-label fw-bolder fs-2 mb-1'>
                All {params.campType?.toUpperCase()} Message
              </span>
              <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
            </h3>
            <div className='d-flex justify-content-end'>
              <div className='col-md-3'>
                <div className='d-flex'>
                  <DatePicker
                    selectsRange={true}
                    dateFormat='MMM d, yyyy'
                    className=' border-0 form-control form-control-lg form-control-solid'
                    placeholderText='Pick data & time'
                    onChange={(update) => {
                      setDateParams(update)
                    }}
                    startDate={startDate}
                    endDate={endDate}
                    disabled={isLoading}
                  />
                  <span
                    className='input-group-text'
                    style={{backgroundColor: '#f5f8fa', borderRadius: 0, borderColor: '#f5f8fa'}}
                  >
                    <i className='bi bi-calendar'></i>
                  </span>
                </div>
              </div>
              <div className='ms-2 col-xs-4 col-md-3 '>
                <Select
                  value={
                    MessageDeliveryOptions.find((e) => e.value === params.status) ||
                    MessageDeliveryOptions[0]
                  }
                  options={MessageDeliveryOptions}
                  onChange={(e) => {
                    setParams({...params, status: e?.value})
                    triggerFetch(true)
                  }}
                  isDisabled={isLoading}
                />
              </div>

              <div className='ms-2 col-xs-4 col-md-3 '>
                <Select
                  value={
                    requestFromOptions
                      .flatMap((e) => e.options)
                      .find((e) => {
                        if (params.requestFrom === 'API') {
                          return e.value === params.requestName
                        }
                        return e.value === params.requestFrom
                      }) || requestFromOptions[0]
                  }
                  options={requestFromOptions}
                  onChange={(e: any) => {
                    if (e?.value === 'APP' || e?.value === 'EMAIL') {
                      setParams({...params, requestFrom: e?.value, requestName: ''})
                    } else {
                      setParams({...params, requestFrom: 'API', requestName: e?.value})
                    }
                    triggerFetch(true)
                  }}
                  isDisabled={isLoading}
                />
              </div>

              <div className='ms-2'>
                <button type='button' onClick={donwloadData} className='btn btn-light-primary'>
                  {isLoadingDownload ? (
                    <Spinner size='sm' />
                  ) : (
                    <>
                      <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                      Export
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data.items && data.data.items.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5 all-message-table'>
                    <thead>
                      <tr className='fw-400 text-muted'>
                        <th className='p-0 min-w-100px'>Type</th>
                        <th className='p-0'>Source Type</th>
                        <th className='p-0'>Sent Date</th>
                        <th className='p-0 min-w-30px ps-3'>From Sender ID</th>
                        <th className='p-0 min-w-30px ps-3'>To Number</th>
                        <th className='p-0 min-w-60px ps-3'>Message</th>
                        <th className='p-0 min-w-60px ps-3'>Reply</th>
                        <th className='p-0 min-w-30px ps-3'>Message Part</th>
                        <th className='p-0 min-w-30px ps-3'>Credit</th>
                        <th className='p-0 min-w-30px ps-3'>Status</th>
                        <th className='p-0 min-w-30px ps-3'>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching ? (
                        <tr>
                          <td colSpan={7} className='text-center'>
                            <Spinner />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {data?.data?.items?.map((key, i: number) => (
                            <React.Fragment key={i}>
                              <tr className='border-dashed border-2 border-bottom'>
                                <td className='top-align'>
                                  <div className='symbol symbol-50px me-2'>
                                    <span
                                      className={`symbol-label badge ${
                                        params.campType?.toUpperCase() === 'MMS' ? 'blue' : 'green'
                                      }_text_badge fs-7 badge-square p-4 w-50px h-50px`}
                                    >
                                      {params.campType?.toUpperCase()}
                                    </span>
                                  </div>
                                </td>
                                <td className='top-align'>{key.request_name || 'Quick Message'}</td>
                                <td className='top-align'>
                                  <span className='text-dark-400'>
                                    {moment(key?.scheduleAt || key?.createdAt).format(
                                      'MMMM DD, YYYY hh:mm A'
                                    )}
                                  </span>
                                </td>
                                <td className='top-align'>{key?.sender || '-'}</td>
                                <td className='top-align'>{key?.receiver || '-'}</td>
                                <td className='top-align'>
                                  <div className='message-display'>{key?.message || '-'}</div>
                                  {key.media && Array.isArray(key.media) && key.media.length > 0 && (
                                    <>
                                      <br />
                                      <Button
                                        size='sm'
                                        className='btm btn-sm mt-5'
                                        onClick={() => {
                                          setImageUrl(key.media ? key.media[0].url : '')
                                          setShowImageModal(true)
                                          if (
                                            key.media &&
                                            key?.media[0]?.filetype === 'text/vcard'
                                          ) {
                                            setIsVCard(true)
                                          }
                                        }}
                                      >
                                        {key.media && key?.media[0]?.filetype === 'text/vcard'
                                          ? 'Show VCard'
                                          : 'Show Image'}
                                      </Button>
                                    </>
                                  )}
                                </td>
                                <td className='top-align'>
                                  <div className='message-display'>
                                    {key.customerResponse || '-'}
                                  </div>
                                  {key.customerResponseMedia &&
                                    Array.isArray(key.customerResponseMedia) &&
                                    key.customerResponseMedia.length > 0 && (
                                      <>
                                        <br />
                                        <Button
                                          size='sm'
                                          className='btm btn-sm mt-5'
                                          onClick={() => {
                                            setImageUrl(
                                              key.customerResponseMedia
                                                ? key.customerResponseMedia[0].url
                                                : ''
                                            )
                                            setShowImageModal(true)
                                          }}
                                        >
                                          Show Image
                                        </Button>
                                      </>
                                    )}
                                </td>
                                <td className='top-align text-center'>
                                  {key.smsDetail && key.smsDetail.smscount
                                    ? key.smsDetail.smscount
                                    : '--'}
                                </td>
                                <td className='top-align text-center'>
                                  {key?.creditAmount && key?.creditAmount
                                    ? key?.creditAmount
                                    : '--'}
                                </td>
                                <td className='top-align'>
                                  <span
                                    className={`badge badge-light-${
                                      ['received', 'delivered'].includes(key?.status)
                                        ? 'success'
                                        : ['failed', 'expired', 'rejected'].includes(key?.status)
                                        ? 'danger'
                                        : 'warning'
                                    } fw-bold`}
                                  >
                                    {key.status ? key.status.toUpperCase() : 'Pending'}
                                  </span>
                                </td>

                                <td className='top-align'>
                                  {key?.status?.toLowerCase() === 'scheduled' ? (
                                    <OverlayTrigger
                                      placement='top'
                                      overlay={<Tooltip id='button-tooltip'>Cancel</Tooltip>}
                                    >
                                      <button
                                        className='btn btn-disable btn-sm btn-icon btn-bg-light btn-danger ms-3'
                                        onClick={() => {
                                          setCancelIdParam(key?._id)
                                          setIsOpenCancelConfirmation(true)
                                        }}
                                      >
                                        {cancelCampaignLoading &&
                                        [key?._id].includes(cancelIdParam) ? (
                                          <Spinner />
                                        ) : (
                                          <i className='bi bi-x fs-5'></i>
                                        )}
                                      </button>
                                    </OverlayTrigger>
                                  ) : (
                                    '-'
                                  )}
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className='abcd'>
                  <select
                    onChange={(e: any) => {
                      setParams({...params, limit: e.target.value})
                      triggerFetch(true)
                    }}
                    value={params.limit || 10}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  {isFetching
                    ? '. . . . .'
                    : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${
                        data.data.total ? data.data.total : 0
                      } Messages`}
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={data?.data?.totalPages}
                    onPageChange={(e: any) => {
                      setParams({...params, page: e.selected + 1})
                      triggerFetch(true)
                    }}
                    containerClassName={'pagination'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            ) : (
              <NodataYet message='No recent api messages (yet!)' />
            )}
          </>
        )}
      </div>
    </div>
  )
}

const QuickMessagesRegion: FC<QuickMessageProps> = (props) => {
  const userData = useSelector(getAllUserDetails)

  const userRegion = useSelector(getDefaultRegion)
  const [requestFromOptions, setRequestFromOptions] = useState([
    {
      label: 'select message source type',
      options: [],
    },
    {
      label: 'Non Api',
      options: [
        {
          label: 'Quick Message',
          value: 'APP',
        },
        {
          label: 'Email To Sms',
          value: 'EMAIL',
        },
      ],
    },
    {
      label: 'API',
      options: [],
    },
  ])

  const {calculate, loadedData, setLoadedData} = useLoadedData()
  const {isFetching, isLoading, data, params, setParams, triggerFetch} = props

  const API_DOMAIN = ENV().REACT_APP_DOMAIN

  const today = new Date() // Current date
  const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([sevenDaysAgo, new Date()])
  const [startDate, endDate] = dateRange

  const [showImageUrl, setImageUrl] = useState('')
  const [showImageModal, setShowImageModal] = useState(false)

  const setDateParams = (dateRangeParams: [Date | null, Date | null]) => {
    let [startDate, endDate] = dateRangeParams

    if (endDate === null) {
      endDate = new Date()
    }

    setParams({
      ...params,
      fromDate: moment(startDate).format('YYYY-MM-DD'),
      toDate: moment(endDate).format('YYYY-MM-DD'),
    })

    triggerFetch(true)
    setDateRange(dateRangeParams)
  }

  const [getApiExport, {isLoading: isLoadingDownload}] = useLazyAllMessageReportExportQuery()

  const donwloadData = () => {
    getApiExport(params)
      .unwrap()
      .then((res) => {
        window.open(`${API_DOMAIN}${res.data.downloadurl}`, '_self')
      })
  }

  useEffect(() => {
    if (data) {
      const loadedData = calculate(
        data && data.data.current ? data.data.current : 1,
        params.limit,
        data && data.data.total ? data.data.total : 0
      )
      setLoadedData(loadedData)
    }
  }, [isLoading, isFetching])

  useEffect(() => {
    if (userData?.tokens && Array.isArray(userData?.tokens)) {
      const apiKeyOptions = userData?.tokens?.map((el: any) => ({
        label: el?.name,
        value: el?.name,
      }))

      if (apiKeyOptions.length > 0) {
        const tmpFilter: any = [...requestFromOptions]
        tmpFilter[3] = {
          label: 'API',
          options: apiKeyOptions,
        }

        setRequestFromOptions(tmpFilter)
      }
    }
  }, [userData])

  const ImagePreviewModal = useMemo(
    () => (
      <ImageModal
        show={showImageModal}
        url={showImageUrl}
        onClose={() => {
          setShowImageModal(false)
          setImageUrl('')
        }}
      />
    ),
    [showImageModal, showImageUrl]
  )

  return (
    <div className='mt-8'>
      {ImagePreviewModal}
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-10'>
          <div className='d-flex flex-column w-100'>
            <h3 className='card-title align-items-start  flex-column'>
              <span className='card-label fw-bolder fs-2 mb-1'>All Message</span>
              <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
            </h3>
            <div className='d-flex justify-content-end'>
              <div className='col-md-3'>
                <div className='d-flex'>
                  <DatePicker
                    selectsRange={true}
                    dateFormat='MMM d, yyyy'
                    className=' border-0 form-control form-control-lg form-control-solid'
                    placeholderText='Pick data & time'
                    onChange={(update) => {
                      setDateParams(update)
                    }}
                    startDate={startDate}
                    endDate={endDate}
                    disabled={isLoading}
                  />
                  <span
                    className='input-group-text'
                    style={{backgroundColor: '#f5f8fa', borderRadius: 0, borderColor: '#f5f8fa'}}
                  >
                    <i className='bi bi-calendar'></i>
                  </span>
                </div>
              </div>
              <div className='ms-2 col-xs-4 col-md-3 '>
                <Select
                  value={
                    MessageDeliveryOptions.find((e) => e.value === params.status) ||
                    MessageDeliveryOptions[0]
                  }
                  options={MessageDeliveryOptions}
                  onChange={(e) => {
                    setParams({...params, status: e?.value})
                    triggerFetch(true)
                  }}
                  isDisabled={isLoading}
                />
              </div>

              <div className='ms-2 col-xs-4 col-md-3 '>
                <Select
                  value={
                    requestFromOptions
                      .flatMap((e) => e.options)
                      .find((e) => {
                        if (params.requestFrom === 'API') {
                          return e.value === params.requestName
                        }
                        return e.value === params.requestFrom
                      }) || requestFromOptions[0]
                  }
                  options={requestFromOptions}
                  onChange={(e: any) => {
                    if (e?.value === 'APP' || e?.value === 'EMAIL') {
                      setParams({...params, requestFrom: e?.value, requestName: ''})
                    } else {
                      setParams({...params, requestFrom: 'API', requestName: e?.value})
                    }
                    triggerFetch(true)
                  }}
                  isDisabled={isLoading}
                />
              </div>

              {/* <div className='ms-2'>
                <button type='button' onClick={donwloadData} className='btn btn-light-primary'>
                  {isLoadingDownload ? (
                    <Spinner size='sm' />
                  ) : (
                    <>
                      <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                      Export
                    </>
                  )}
                </button>
              </div> */}
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data.items && data.data.items.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5 all-message-table'>
                    <thead>
                      <tr className='fw-400 text-muted'>
                        <th className='p-0 min-w-100px'>Type</th>
                        <th className='p-0'>Source Type</th>
                        <th className='p-0'>Date</th>
                        <th className='p-0 min-w-30px ps-3'>From Sender ID</th>
                        <th className='p-0 min-w-30px ps-3'>To Number</th>
                        <th className='p-0 min-w-60px ps-3'>Message</th>
                        <th className='p-0 min-w-60px ps-3'>Reply</th>
                        <th className='p-0 min-w-30px ps-3'>Message Part</th>
                        <th className='p-0 min-w-30px ps-3'>Credit</th>
                        <th className='p-0 min-w-30px ps-3'>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching ? (
                        <tr>
                          <td colSpan={7} className='text-center'>
                            <Spinner />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {data?.data?.items?.map((key, i: number) => (
                            <React.Fragment key={i}>
                              <tr className='border-dashed border-2 border-bottom'>
                                <td className='top-align'>
                                  <div className='symbol symbol-50px me-2'>
                                    <span
                                      className={`symbol-label badge ${
                                        key.type?.toUpperCase() === 'MMS' ? 'blue' : 'green'
                                      }_text_badge fs-7 badge-square p-4 w-50px h-50px`}
                                    >
                                      {key.type?.toUpperCase()}
                                    </span>
                                  </div>
                                </td>
                                <td className='top-align'>{key.request_name || 'Quick Message'}</td>
                                <td className='top-align'>
                                  <span className='text-dark-400  p-0'>
                                    {moment(key?.created_at).format('DD-MM-YYYY HH:mm:ss')}
                                  </span>
                                </td>
                                <td className='top-align'>{key?.sender || '-'}</td>
                                <td className='top-align'>{key?.receiver || '-'}</td>
                                <td className='top-align'>
                                  <div className='message-display'>{key?.message || '-'}</div>
                                  {key.media && Array.isArray(key.media) && key.media.length > 0 && (
                                    <>
                                      <br />
                                      <Button
                                        size='sm'
                                        className='btm btn-sm mt-5'
                                        onClick={() => {
                                          setImageUrl(key.media ? key.media[0].url : '')
                                          setShowImageModal(true)
                                        }}
                                      >
                                        Show Image
                                      </Button>
                                    </>
                                  )}
                                </td>
                                <td className='top-align'>
                                  <div className='message-display'>
                                    {key?.response_message?.message || '-'}
                                  </div>
                                  {[REGION.UK, REGION.US].includes(userRegion) ? (
                                    <>
                                      {key?.response_message &&
                                        Array.isArray(key?.response_message?.media) &&
                                        key?.response_message?.media.length > 0 && (
                                          <>
                                            <br />
                                            <Button
                                              size='sm'
                                              className='btm btn-sm mt-5'
                                              onClick={() => {
                                                setImageUrl(
                                                  key?.response_message?.media
                                                    ? (key?.response_message?.media[0]
                                                        ?.url as string)
                                                    : ''
                                                )
                                                setShowImageModal(true)
                                              }}
                                            >
                                              Show Image
                                            </Button>
                                          </>
                                        )}
                                    </>
                                  ) : null}
                                </td>
                                <td className='top-align text-center'>
                                  {key?.message_part ? key.message_part : '--'}
                                </td>
                                <td className='top-align text-center'>
                                  {key?.credit_amount && key?.credit_amount
                                    ? key?.credit_amount
                                    : '--'}
                                </td>
                                <td className='top-align'>
                                  <span
                                    className={`badge badge-light-${
                                      ['received', 'delivered'].includes(key?.status)
                                        ? 'success'
                                        : ['failed', 'expired', 'rejected'].includes(key?.status)
                                        ? 'danger'
                                        : 'warning'
                                    } fw-bold`}
                                  >
                                    {key.status ? key.status.toUpperCase() : 'Pending'}
                                  </span>
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className='abcd'>
                  <select
                    onChange={(e: any) => {
                      setParams({...params, limit: e.target.value})
                      triggerFetch(true)
                    }}
                    value={params.limit || 10}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  {isFetching
                    ? '. . . . .'
                    : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${
                        data.data.total ? data.data.total : 0
                      } Messages`}
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={data?.data?.totalPages}
                    onPageChange={(e: any) => {
                      setParams({...params, page: e.selected + 1})
                      triggerFetch(true)
                    }}
                    containerClassName={'pagination'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            ) : (
              <NodataYet message='No recent api messages (yet!)' />
            )}
          </>
        )}
      </div>
    </div>
  )
}

type QuickMessageGroupProps = {
  campType: CampType
}

const QuickMessagesGroup: FC<QuickMessageGroupProps> = (props) => {
  const today = new Date() // Current date
  const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)
  const API_DOMAIN = ENV().REACT_APP_DOMAIN

  const [
    fetchNonApiCredit,
    {isLoading: nonApiLoading, isFetching: nonApiFetching},
  ] = useLazyAllMessageCreditUsageReportQuery()
  const [
    fetchApiCredit,
    {isLoading: apiLoading, isFetching: apiFetching},
  ] = useLazyAllMessageCreditUsageReportQuery()

  const [nonApiData, setNonApiData] = useState<MessageReportItems[]>([])
  const [apiData, setApiData] = useState<MessageReportItems[]>([])
  const [allData, setAllData] = useState<MessageReportItems[]>([])

  const [triggerFetch, setTriggerFetch] = useState(true)
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([sevenDaysAgo, new Date()])
  const [startDate, endDate] = dateRange

  const [nonApiParams, setNonApiParams] = useState<MessageReportParams>({
    campType: props.campType,
    fromDate: moment(sevenDaysAgo).format('YYYY-MM-DD'),
    toDate: moment(today).format('YYYY-MM-DD'),
    requestFromExclude: 'API',
    groupBy: 'request_from',
  })

  const [apiParams, setApiParams] = useState<MessageReportParams>({
    campType: props.campType,
    fromDate: moment(sevenDaysAgo).format('YYYY-MM-DD'),
    toDate: moment(today).format('YYYY-MM-DD'),
    requestFrom: 'API',
    groupBy: 'request_name',
  })

  const setDateParams = (dateRangeParams: [Date | null, Date | null]) => {
    let [startDate, endDate] = dateRangeParams

    if (endDate === null) {
      endDate = new Date()
    }

    setNonApiParams({
      ...nonApiParams,
      fromDate: moment(startDate).format('YYYY-MM-DD'),
      toDate: moment(endDate).format('YYYY-MM-DD'),
    })

    setApiParams({
      ...apiParams,
      fromDate: moment(startDate).format('YYYY-MM-DD'),
      toDate: moment(endDate).format('YYYY-MM-DD'),
    })

    setDateRange(dateRangeParams)
    setTriggerFetch(true)
  }

  const [
    getCreditUsageApiExport,
    {isLoading: isLoadingDownloadCredit},
  ] = useLazyGetMessageCreditUsageReportExportQuery()
  const donwloadCreditUsageData = () => {
    getCreditUsageApiExport(apiParams)
      .unwrap()
      .then((res) => {
        window.open(`${API_DOMAIN}${res.data.downloadurl}`, '_self')
      })
  }

  useEffect(() => {
    if (triggerFetch) {
      fetchNonApiCredit(nonApiParams)
        .then((res) => {
          if ('data' in res) {
            const responseData = [...(res?.data?.data?.items || [])]
            setNonApiData(responseData)
          } else if ('error' in res) {
            toast.error(res.error)
            console.error('Error Fetch Message Credit Usage:', res.error)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })

      fetchApiCredit(apiParams)
        .then((res) => {
          if ('data' in res) {
            setApiData(res?.data?.data?.items || [])
          } else if ('error' in res) {
            toast.error(res.error)
            console.error('Error Fetch Message Credit Usage:', res.error)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })

      setTriggerFetch(false)
    }
  }, [triggerFetch])

  useEffect(() => {
    setAllData([...nonApiData, ...apiData])
  }, [nonApiData, apiData])

  return (
    <div className='mt-8'>
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-10'>
          <div className='d-flex justify-content-between align-items-center w-100'>
            <h3 className='card-title align-items-start flex-column m-0'>
              <span className='card-label fw-bolder fs-2 mb-1'>
                All {props.campType?.toUpperCase()} Credit Usage
              </span>
              <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
            </h3>
            <div className='d-flex align-items-center'>
              <div className='d-flex'>
                <DatePicker
                  selectsRange={true}
                  dateFormat='MMM d, yyyy'
                  className=' border-0 form-control form-control-lg form-control-solid'
                  placeholderText='Pick data & time'
                  onChange={(update) => {
                    setDateParams(update)
                  }}
                  startDate={startDate}
                  endDate={endDate}
                  disabled={apiLoading && nonApiLoading}
                />
                <span
                  className='input-group-text'
                  style={{backgroundColor: '#f5f8fa', borderRadius: 0, borderColor: '#f5f8fa'}}
                >
                  <i className='bi bi-calendar'></i>
                </span>
              </div>
              <div className='ms-2'>
                <button
                  type='button'
                  onClick={() => donwloadCreditUsageData()}
                  className='btn btn-light-primary'
                >
                  {isLoadingDownloadCredit ? (
                    <Spinner size='sm' />
                  ) : (
                    <>
                      <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                      Export
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className='row mb-8'>
          <div className='col-md-6'>
            <QMAndAPIStatisticGraph
              campType={props.campType}
              fromDate={nonApiParams.fromDate}
              toDate={nonApiParams.toDate}
            />
          </div>
          <div className='col-md-6'>
            <MessageSentVsCreditCostGraph
              campType={props.campType}
              fromDate={nonApiParams.fromDate}
              toDate={nonApiParams.toDate}
            />
          </div>
        </div>

        {apiLoading && nonApiLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {allData && allData.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5 all-message-table'>
                    <thead>
                      <tr className='fw-400 text-muted'>
                        <th className='p-0 min-w-30px'>Source Type</th>
                        <th className='p-0 min-w-30px ps-3'>
                          Total {props.campType?.toUpperCase()} Credit
                        </th>
                        <th className='p-0 min-w-30px ps-3'>
                          Total {props.campType?.toUpperCase()}
                        </th>
                        <th className='p-0 min-w-30px ps-3'>
                          Total {props.campType?.toUpperCase()} Parts
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {apiFetching && nonApiFetching ? (
                        <tr>
                          <td colSpan={7} className='text-center'>
                            <Spinner />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {allData?.map((key, i: number) => (
                            <React.Fragment key={i}>
                              <tr className='border-dashed border-2 border-bottom'>
                                <td className='top-align'>
                                  {key?._id === 'APP' ? 'Quick Message' : key?._id?.toUpperCase()}
                                </td>
                                <td className='top-align'>{key?.totalCreditAmount || '-'} </td>
                                <td className='top-align'>{key?.totalSms || '-'} </td>
                                <td className='top-align'>{key?.total || '-'}</td>
                              </tr>
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <NodataYet message='No recent api messages (yet!)' />
            )}
          </>
        )}
      </div>
    </div>
  )
}

type QMAndAPIStatisticGraphProps = {
  campType: CampType
  fromDate?: string
  toDate?: string
}

const QMAndAPIStatisticGraph: FC<QMAndAPIStatisticGraphProps> = ({campType, fromDate, toDate}) => {
  const {data, isLoading, isFetching} = useGetDashboardQMAndAPIStatisticQuery({
    fromDate,
    toDate,
    camp_type: campType,
  })

  const graphData = data?.data?.[0]

  const qmMessageCountData =
    graphData?.qmMessageCount?.length > 0
      ? graphData?.qmMessageCount?.map((key: any) => [
          +moment.utc(key?._id).format('x'),
          key?.count,
        ])
      : []

  const apiMessageCountData =
    graphData?.apiMessageCount?.length > 0
      ? graphData?.apiMessageCount?.map((key: any) => [
          +moment.utc(key?._id).format('x'),
          key?.count,
        ])
      : []

  const chartOptions: any = {
    series: [
      {
        name: 'Quick Message',
        data: qmMessageCountData,
      },
      {
        name: 'API',
        data: apiMessageCountData,
      },
    ],
    options: {
      chart: {
        type: 'area',
        stacked: false,
        height: 350,
        zoom: {
          type: 'x',
          enabled: false,
          autoScaleYaxis: true,
        },
        toolbar: {
          show: false,
          autoSelected: 'zoom',
        },
      },
      colors: ['#009ef7', '#50cd89'],
      noData: {
        text: 'No data yet',
        align: 'center',
        verticalAlign: 'middle',
        style: {
          fontSize: '20px',
          color: '#a6a6b1',
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      title: {
        text: '',
        align: 'left',
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
      },
      yaxis: {
        labels: {
          formatter: function(val: any) {
            return val?.toFixed(0)
          },
        },
        title: {
          text: '',
        },
      },
      xaxis: {
        type: 'datetime',
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function(val: any) {
            return val?.toFixed(0)
          },
        },
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
      },
    },
  }

  return (
    <div className='mb-5'>
      <h3 className='align-items-center flex-column mb-3 text-center'>
        <span className='fw-bolder fs-5 mb-1'>Quick Message vs API</span>
        <span className='text-muted fw-light fs-7 d-block'>Message distribution by source</span>
      </h3>
      {isLoading || isFetching ? (
        <div className='d-flex justify-content-center align-items-center h-300px'>
          <Spinner />
        </div>
      ) : (
        <ReactApexChart
          options={chartOptions.options}
          series={chartOptions.series}
          type='area'
          height={300}
          width='100%'
        />
      )}
    </div>
  )
}

type MessageSentVsCreditCostGraphProps = {
  campType: CampType
  fromDate?: string
  toDate?: string
}

const MessageSentVsCreditCostGraph: FC<MessageSentVsCreditCostGraphProps> = ({
  campType,
  fromDate,
  toDate,
}) => {
  const {data, isLoading, isFetching} = useGetDashboardMessageSentVsCreditCostQuery({
    fromDate,
    toDate,
    camp_type: campType,
  })

  const graphData = data?.data?.[0]

  const messageSentCountData =
    graphData?.messageSentCount?.length > 0
      ? graphData?.messageSentCount?.map((key: any) => [
          +moment.utc(key?._id).format('x'),
          key?.count,
        ])
      : []

  const creditCostData =
    graphData?.creditCost?.length > 0
      ? graphData?.creditCost?.map((key: any) => [+moment.utc(key?._id).format('x'), key?.count])
      : []

  const messagePartsData =
    graphData?.messageParts?.length > 0
      ? graphData?.messageParts?.map((key: any) => [+moment.utc(key?._id).format('x'), key?.count])
      : []

  const chartOptions: any = {
    series: [
      {
        name: 'Messages Sent',
        data: messageSentCountData,
      },
      {
        name: 'Credit Usage',
        data: creditCostData,
      },
      {
        name: 'Message Parts',
        data: messagePartsData,
      },
    ],
    options: {
      chart: {
        type: 'area',
        stacked: false,
        height: 350,
        zoom: {
          type: 'x',
          enabled: false,
          autoScaleYaxis: true,
        },
        toolbar: {
          show: false,
          autoSelected: 'zoom',
        },
      },
      colors: ['#009ef7', '#f1416c', '#50cd89'],
      noData: {
        text: 'No data yet',
        align: 'center',
        verticalAlign: 'middle',
        style: {
          fontSize: '20px',
          color: '#a6a6b1',
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      title: {
        text: '',
        align: 'left',
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
      },
      yaxis: {
        labels: {
          formatter: function(val: any) {
            return val?.toFixed(0)
          },
        },
        title: {
          text: '',
        },
      },
      xaxis: {
        type: 'datetime',
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function(val: any, opts: any) {
            return val?.toFixed(0)
          },
        },
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
      },
    },
  }

  return (
    <div className='mb-5'>
      <h3 className='align-items-center flex-column mb-3 text-center'>
        <span className='fw-bolder fs-5 mb-1'>Messages Sent vs Credit Usage</span>
        <span className='text-muted fw-light fs-7 d-block'>
          Message count, credit usage and parts
        </span>
      </h3>
      {isLoading || isFetching ? (
        <div className='d-flex justify-content-center align-items-center h-300px'>
          <Spinner />
        </div>
      ) : (
        <ReactApexChart
          options={chartOptions.options}
          series={chartOptions.series}
          type='area'
          height={300}
          width='100%'
        />
      )}
    </div>
  )
}

export default ActivityLogsPage

type ImageModalProps = {
  show: boolean
  url: string
  isVCard?: boolean
  onClose: () => void
}
const ImageModal: FC<ImageModalProps> = (props) => {
  const {isVCard, show, url, onClose} = props

  const getMediaType = (url: string): 'image' | 'video' | 'unknown' => {
    const ext = url
      .split('.')
      .pop()
      ?.toLowerCase()
    if (!ext) return 'unknown'
    if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(ext)) return 'image'
    if (['mp4', 'mov', 'webm', 'ogg'].includes(ext)) return 'video'
    return 'unknown'
  }

  const mediaType = isVCard ? 'vcard' : getMediaType(url)

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Body>
        <div className='card-header'>
          <div className='card-title'>
            <h2 className='text-center'>
              {isVCard
                ? 'VCard Preview'
                : mediaType === 'video'
                ? 'Video Preview'
                : 'Image Preview'}
            </h2>
          </div>
          <div className='card-toolbar align-items-center'></div>
        </div>
        <div className='card-body p-0 text-center'>
          {mediaType === 'vcard' ? (
            <VCardPreview vcfUrl={url} />
          ) : mediaType === 'video' ? (
            <video src={url} controls style={{width: '100%', height: 'auto', borderRadius: '8px'}}>
              Your browser does not support the video tag.
            </video>
          ) : mediaType === 'image' ? (
            <img
              src={url}
              alt='Preview'
              style={{width: '100%', height: 'auto', borderRadius: '8px'}}
            />
          ) : (
            <p>Cannot preview this file type.</p>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
